import React, {ReactNode} from "react";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import {setModalVisibility} from "../../core/app/setModalVisibility/actions";
import {ModalType} from "../../core/models/custom/enums/modalType";
import {ModalVisibilityPayload} from "../../core/models/custom/modalVisibility.payload";
import {LeaderboardDto} from "../../core/models/dtos/leaderboard.dto";
import FirebaseService from "../../core/services/firebase.service";
import {getLeaderboard} from "../../core/services/userService/getLeaderboard/actions";
import {GetLeaderboardState} from "../../core/services/userService/getLeaderboard/types";
import ContentKeys from "../../core/utilities/contentKeys";
import {withRouter, WithRouterProps} from "../../core/utilities/hooks";
import {IStore} from "../../core/utilities/reducers";
import {router} from "../../core/utilities/router";
import HomeButton from "../Buttons/HomeButton/HomeButton";
import ContentKey from "../ContentKey/ContentKey";
import Loading from "../Loading/Loading";
import "./Leaderboard.scss";
import Rankings from "./Rankings/Rankings";
import UserData from "./UserData/UserData";

interface IProps {
  getLeaderboardState: GetLeaderboardState;
  getLeaderboard: () => void;
  setModalVisibility: (payload: ModalVisibilityPayload) => void;
}

class Leaderboard extends React.Component<WithRouterProps<IProps>> {
  
  componentDidMount() {
    this.props.getLeaderboard();
  }
  
  private handleCampaign(): void {
    this.props.setModalVisibility({modal: ModalType.SCOREBOARD, isVisible: true});
  }
  
  private handlePlay(): void {
    FirebaseService.logEvent(FirebaseService.user_count_kmb_home_play_click);
    this.props.navigate(router.QUESTION);
  }
  
  private renderUserData(leaderboard: LeaderboardDto): ReactNode {
    return (
      <UserData
        leaderboard={leaderboard}
        callbackCampaign={() => this.handleCampaign()}
      />
    );
  }
  
  private renderRankings(leaderboard: LeaderboardDto): ReactNode {
    return (
      <Rankings leaderboard={leaderboard}/>
    );
  }
  
  private renderLeaderboard(): ReactNode {
    if (this.props.getLeaderboardState.loading) {
      return <Loading size="large"/>
    } else if (this.props.getLeaderboardState.data) {
      return (
        <React.Fragment>
          <div className="content-mobile d-flex flex-column d-md-none">
            {this.renderUserData(this.props.getLeaderboardState.data)}
            {this.renderRankings(this.props.getLeaderboardState.data)}
          </div>
          <div className="d-none d-md-flex justify-content-between">
            {this.renderRankings(this.props.getLeaderboardState.data)}
            {this.renderUserData(this.props.getLeaderboardState.data)}
          </div>
          <div className="d-flex flex-column align-items-center">
            <HomeButton
              child={<ContentKey contentKey={ContentKeys.HOME_PLAY_BUTTON}/>}
              callback={() => this.handlePlay()}
            />
          </div>
        </React.Fragment>
      );
    }
    return <React.Fragment/>
  }
  
  render() {
    return (
      <div id="leaderboard">
        {this.renderLeaderboard()}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      getLeaderboard,
      setModalVisibility,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    getLeaderboardState: store.getLeaderboard,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter<IProps>(Leaderboard));
